import { BellIcon } from "@heroicons/react/24/outline"

export const AlertHeaderCell = () => {
  return <BellIcon width={20} />
}